


































































































































































































































































































































































import { Component, Prop, Provide, Vue } from 'vue-property-decorator'
import { jzdx, yqxyy, SongGuo, ResourceType, ad, GR, weMedia, qk } from '../../../service/common'
import { TaskInstance } from '../types/task'

@Component
export default class TaskInfo extends Vue {
  @Prop() public data!: TaskInstance
  public urlReg = /^((https|http|ftp|rtsp|mms)?:\/\/)[^\s]+/

  private get isJzdx() {
    // 判断是否是家长大学的任务, 用来做特殊处理
    return jzdx.isJzdx(this.data)
  }

  public get jzdxUser() {
    return jzdx.get_jzdxUser(this.data)
  }
  public get jzdxTopic() {
    return jzdx.get_jzdxTopic(this.data)
  }

  public get jzdxStand() {
    return jzdx.get_jzdxStand(this.data)
  }

  public get jzdxTime() {
    return jzdx.get_jzdxTime(this.data)
  }

  public get jzdxComment() {
    return jzdx.get_jzdxComment(this.data)
  }

  // 判断是否是轻课的任务, 用来做特殊处理
  private get isQk() {
    return qk.isQk(this.data)
  }
  // 轻课字段 start
  private get displayUserName() {
    return (
      this.data &&
      this.data.resource &&
      this.data.resource.extras &&
      this.data.resource.extras.username
    )
  }

  private get qkUserPic() {
    return (
      this.data &&
      this.data.resource &&
      this.data.resource.extras &&
      this.data.resource.extras.avatar
    )
  }

  private get qkContentTitle() {
    return (
      this.data &&
      this.data.resource &&
      this.data.resource.extras &&
      this.data.resource.extras.title
    )
  }
  private get qkShareUrl() {
    return (
      this.data &&
      this.data.resource &&
      this.data.resource.extras &&
      this.data.resource.extras.share_url
    )
  }
  // 轻课字段 end

  private get displayResourceSource() {
    return this.data && this.data.resource && this.data.resource.business_type_name
  }

  private get displaySubject() {
    return this.data && this.data.resource && this.data.resource.subject_name
  }

  private get displayResourceId() {
    return this.data && this.data.resource && this.data.resource.doc_id
  }

  private get userId() {
    return this.data && this.data.user_id
  }

  private get displayResourceOwner() {
    return this.data && this.data.resource && this.data.resource.resource_owner_name
  }

  private get displayAuditType() {
    return this.data && this.data.resource && this.data.approve_type
  }

  private get displaySensitiveWords() {
    const words = (this.data && this.data.resource && this.data.resource.sensitive_words) || []
    return words.map((item) => item.name).join(', ')
  }

  private get displayResourceUrl() {
    return this.data && this.data.resource && this.data.resource.resource_url
  }

  // 一起学运营
  private get isYqxyy() {
    // 判断是否是家长大学的任务, 用来做特殊处理
    return yqxyy.isYqxyy(this.data)
  }

  private get yqxyyResourceId() {
    return this.data && this.data.resource && this.data.resource.doc_id
  }

  private get yqxyyResourceUrl() {
    return (
      this.data &&
      this.data.resource &&
      this.data.resource.extras &&
      this.data.resource.extras.picture_url
    )
  }
  private get yqxyyUserId() {
    return (
      this.data &&
      this.data.resource &&
      this.data.resource.extras &&
      this.data.resource.extras.user_id
    )
  }
  private get yqxyyIdiom() {
    return (
      this.data &&
      this.data.resource &&
      this.data.resource.extras &&
      this.data.resource.extras.idiom
    )
  }

  // 直播大讲堂
  private get isGR() {
    return GR.isGR(this.data)
  }
  private get GRTitle() {
    return this.data && this.data.resource && this.data.resource.title
  }

  // 自媒体
  private get isWeMedia() {
    return weMedia.isWeMedia(this.data)
  }
  private get weMediaType() {
    return this.data && this.data.resource && this.data.resource.category_name
  }
  private get weMediaCreator() {
    return this.data && this.data.resource && this.data.resource.creator
  }
  private get weMediaAccountName() {
    return this.data && this.data.resource && this.data.resource.account_name
  }
  private get weMediaSourceName() {
    return this.data && this.data.resource && this.data.resource.source_name
  }
  private get weMediaOperator() {
    return this.data && this.data.resource && this.data.resource.operator
  }
  private get weMediaPublishAt() {
    return this.data && this.data.resource && this.data.resource.publish_at
  }
  private get weMeiaTitle() {
    return this.data && this.data.resource && this.data.resource.title
  }
  private get weMediaResourceData() {
    return this.data && this.data.resource && this.data.resource.resource_data
  }

  // 松果相关
  private get isSongguo() {
    return SongGuo.isSongguo(this.data)
  }

  private get songguoResourceUrl() {
    return SongGuo.songguoUrl(this.data)
  }

  private get displaySongguoCategory() {
    return SongGuo.songguoCategory(this.data)
  }

  private get isSongguoResourceUrlAudio() {
    return ResourceType(this.songguoResourceUrl || '').isAudio()
  }

  private get isSongguoResourceUrlImage() {
    return ResourceType(this.songguoResourceUrl || '').isImage()
  }
  // 松果相关 end

  // 判断资源类型
  private get isYqxyyResourceUrlImage() {
    return ResourceType(this.yqxyyResourceUrl || '').isImage()
  }

  private get isDisplayResourceUrlImage() {
    return ResourceType(this.displayResourceUrl || '').isImage()
  }
  // 判断是否为广告资源
  private get isAd() {
    return ad.isAd(this.data)
  }
  private get resourceData() {
    return this.data && this.data.resource && this.data.resource.resource_data
  }
  public resourceType(data) {
    return ResourceType(data)
  }
  private get resourceTitle() {
    return this.data && this.data.resource && this.data.resource.title
  }
  private get resourceSubTitle() {
    return this.data && this.data.resource && this.data.resource.subtitle
  }
  private get resourceCopyright() {
    return this.data && this.data.resource && this.data.resource.copyright
  }
  private get categoryName() {
    return this.data && this.data.resource && this.data.resource.category_name
  }
  private get cellPhone() {
    return this.data && this.data.resource && this.data.resource.creator_phone_number
  }
  private get subjectID() {
    return this.data && this.data.resource && this.data.resource.subject_id
  }
  private get instanceID() {
    return this.data && this.data.id
  }
}
